import React, { Fragment } from 'react'
import { ForgotPassword } from 'aws-amplify-react'
import { Auth } from 'aws-amplify'
import { Text } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'
import style from './auth.module.scss'
import { validatePassword } from './utils'
import AuthContainer from './AuthContainer'
import { withTranslation } from 'react-i18next'

class MyRequireNewPassword extends ForgotPassword {
	state = { username: '', isSubmitting: false }
	setSubmitState = val => this.setState({ isSubmitting: val })

	getApi = formApi => {
		this.formApi = formApi
	}

	goBack = () => {
		this.setState({ username: '' })
		this.changeState('signIn')
	}

	sendCode = async ({ username }) => {
		const { t } = this.props
		this.setSubmitState(true)
		try {
			await Auth.forgotPassword(username)
			this.setState({ username })
			this.changeState('forgotPassword')
		} catch(err) {
			if(err.code === 'UserNotFoundException') {
				this.formApi.setError('username', t('auth_screen.error.user_not_found'))
			} else if(err.code === 'LimitExceededException') {
				this.formApi.setError('username', t('auth_screen.error.try_limit'))
			}
		} finally {
			this.setSubmitState(false)
		}
	}

	resetPassword = async ({ code, newPassword }) => {
		const { username } = this.state
		const { t } = this.props
		this.setSubmitState(true)
		try {
			await Auth.forgotPasswordSubmit(username, code, newPassword)
			this.setState({ username: '' })
			this.changeState('signIn')
		} catch(err) {
			if(err.code === 'CodeMismatchException') {
				this.formApi.setError('code', t('auth_screen.error.invalid_code'))
			} else if(err.code === 'LimitExceededException') {
				this.formApi.setError('username', t('auth_screen.error.try_limit'))
			}
		} finally {
			this.setSubmitState(false)
		}
	}

	showComponent(theme, { changeState, authState, t } = this.props, { username, isSubmitting } = this.state) {
		return(
			<AuthContainer
				getApi={this.getApi}
				key={username}
				onSubmit={username ? this.resetPassword : this.sendCode}
				className={style.form}
				render={({ formState: { values, errors } }) => (
					<Fragment>
						{username ?
							<p>{t('auth_screen.message.new_pass_required')}</p> :
							<p>{t('auth_screen.message.reset_password')}</p>
						}
						<Divider height={20}/>
						{username ?
							<Fragment>
								<Text
									errors={errors}
									errorClass={style.formInputError}
									validate={v => (v ? null : t('auth_screen.error.code_required'))}
									validateOnChange
									type='text'
									field='code'
									placeholder={t('auth_screen.form.code')}
									usePlaceholder
								/>
								<Text
									errors={errors}
									errorClass={style.formInputError}
									validate={validatePassword(t)}
									autoComplete='new-password'
									validateOnChange
									type='password'
									field='newPassword'
									placeholder={t('auth_screen.form.new_password')}
									usePlaceholder
								/>
							</Fragment> :
							<Text
								errors={errors}
								errorClass={style.formInputError}
								validate={v => (v ? null : t('auth_screen.error.login_required'))}
								validateOnChange
								type='text'
								field='username'
								placeholder={t('auth_screen.form.login')}
								usePlaceholder
							/>
						}
						<Divider height={20}/>
						{username ?
							<Button
								status={Object.keys(errors).length ? 'inactive' : 'active'}
								text={t('auth_screen.button.save_password')}
								type='submit'
								{...isSubmitting && { loading: true }}
							/> :
							<Button
								status={!values.username && errors.username ? 'inactive' : 'active'}
								text={t('auth_screen.button.reset_password')}
								type='submit'
								{...isSubmitting && { loading: true }}
							/>
						}
						<div className={style.linkButton} onClick={this.goBack}>{t('auth_screen.button.go_back')}</div>
					</Fragment>
				)}
			/>
		)
	}
}

export default withTranslation()(MyRequireNewPassword)
